import ApiDataModel from "@/models/apidatamodel"
import DynamicRightSlotData from "@/models/dynamicrighslotdata"
import LocaleHelper from "@/helpers/localeHelper"
import utils from "@/utils/utils"
import ApiService from "@/services/ApiService"
import { store } from '@/store/store'
import i18n from '@/i18n'

const t = i18n.global.t

export default class RadiomikrofonitaajuudetService {
    baseHref = "/" + utils.getCurrentSubdomain()
    apiService = new ApiService(this.baseHref)
    radiomikrofonitaajuudetApiCallBasePart = "v1/Radiomikrofonitaajuudet/"

    async handleRadiomikrofonitaajuudet(data): Promise<ApiDataModel[]> {
        try {
            const apiData = new Array<ApiDataModel>()
            const rightSlotData = new DynamicRightSlotData("0")
            const resIcon = "<img class='reserved-icon' src='" + this.reservedIcon() + "' alt='" + this.getReservedIconAlt() + "' style='width: 1rem; height: 1rem; margin-left: 0.5rem;'/>"

            data.frequencyranges.forEach((value) => {
                const isReservedFrequency = value.frequencytype === 1
                value.start = LocaleHelper.formatDecimal(value.start.toFixed(2))
                value.end = LocaleHelper.formatDecimal(value.end.toFixed(2))

                // if start and end values are the same, then only show the start value - just to mimic the functionality from the old Radiomikrofonitaajuudet
                if (value.start === value.end) {
                    rightSlotData.frequencies?.push(value.start + " MHz" + (isReservedFrequency ? resIcon : ""))
                }
                else {
                    rightSlotData.frequencies?.push(value.start + " - " + value.end + " MHz" + (isReservedFrequency ? resIcon : ""))
                }
                apiData.push(new ApiDataModel("0", true, value.alue, value, rightSlotData, null))
            })

            // Jos rajapinta palauttaa infoviestin, niin välitetään se oikeaan palstaan
            if (data.infomessage != null) {
                switch (store.getters.activeLang) {
                    case "fi":
                        rightSlotData.messageFromApi = data.infomessage.fi.replace(/<.*?>/g, "")
                        break
                    case "sv":
                        rightSlotData.messageFromApi = data.infomessage.sv.replace(/<.*?>/g, "")
                        break
                    case "en":
                        rightSlotData.messageFromApi = data.infomessage.en.replace(/<.*?>/g, "")
                        break
                    default:
                        rightSlotData.messageFromApi = data.infomessage.fi.replace(/<.*?>/g, "")
                        break
                }
            }

            store.dispatch("setRightSlotData", rightSlotData)

            return apiData
        }
        catch (err) {
            return new Array<ApiDataModel>()
        }
    }

    emptyFrequenciesResults(): void {
        const rightSlotData = new DynamicRightSlotData("0")
        rightSlotData.frequencies = null
        store.dispatch("setRightSlotData", rightSlotData)
    }

    availableFrequenciesSearch(clearLocationMarker: boolean = false): void {
        const lat = store.getters.frequencySearchData.lat
        const lng = store.getters.frequencySearchData.lng
        let f1 = store.getters.frequencySearchData.f1
        let f2 = store.getters.frequencySearchData.f2

        // Suoritetaan haku vain, jos validointi onnistuu
        if (this.validateSearchInput(f1, f2)) {
            // Mikäli kyseessä avoin haku (esim. "200-" tai "-444"), niin asetetaan minimi-/maksimitaajuus
            if (f1 === "min") {
                f1 = store.getters.radiomikrofonitMinFrequency
            }
            if (f2 === "max") {
                f2 = store.getters.radiomikrofonitMaxFrequency
            }

            const url = this.radiomikrofonitaajuudetApiCallBasePart + "Radiomikrofonitaajuudet" + "?lat=" + lat + "&lng=" + lng + "&f1=" + f1 + "&f2=" + f2
            store.dispatch("setDataUrlToLoad", { url, type: "Radiomikrofonitaajuudet", clearLocationMarker })
        }
    }

    validateSearchInput(f1: any, f2: any): boolean {
        const doubleF1: number = parseFloat(f1)
        const doubleF2: number = parseFloat(f2)

        // Mikäli ala- ja ylätaajuudet ovat väärinpäin, eli alataajuus on suurempi kuin ylätaajuus, nostetaan validointivirhe ja tyhjennetään hakutulokset
        if (!isNaN(doubleF1) && !isNaN(doubleF2) && doubleF1 > doubleF2) {
            this.emptyFrequenciesResults()
            store.dispatch("setFrequencySearcValidationMessage", "App.Radiomikrofonitaajuudet.ValidationError.NegativeFrequencyRange")
            return false
        }

        // Jos validointivirheitä ei tule, niin tyhjennetään validointivirheen store-muuttuja
        store.dispatch("setFrequencySearcValidationMessage", "")
        return true
    }

    reservedIcon(): string {
        return store.getters.contentServiceUrl + "/Content/icons/svg/huutomerkki-pyorea-punainen.svg" + "?" + store.getters.contentServiceTimeStamp
    }

    getReservedIconAlt(): string | undefined {
        return t("App.Radiomikrofonitaajuudet.ReservedFrequencyAlt")
    }

    get currentLanguage() {
        return store.getters.activeLang
    }
}

export interface Radiomikrofonitaajuudet {
    start: number
    end: number
    frequencyType: number
}
